module.exports = __webpack_public_path__ + "img/tick_icon.5bf2102c.svg";